import LinkList from '@storeblocks/link-list';
import { type FC } from 'react';
import { styled } from 'styled-components';

import { ConnectSurface } from '@/components/Pretzel/ConnectSurface';
import { WithGap } from '@/components/WithGap';
import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

export const AssetAllocationBannerWidget: FC = () => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  const { heading, link1, link2 } = texts.news.tiles.largestAssetManager;

  const links = [
    !!link1.title &&
      !!link1.link && {
        ...link1,
        name: 'link1',
      },
    !!link2.title &&
      !!link2.link && {
        ...link2,
        name: 'link2',
      },
  ].filter((link) => link !== false);

  return (
    <StyledConnectSurface>
      <WithGap gap="16">
        <StyledH2>{heading}</StyledH2>
        <LinkList>
          {links.map((link) => (
            <a
              key={link.link}
              href={link.link}
              target="_blank"
              data-trackid={getTrackId(
                `go-to-asset-allocation-${link.name}`,
                TrackingElement.Link,
              )}
              rel="noreferrer"
            >
              {link.title}
            </a>
          ))}
        </LinkList>
      </WithGap>
    </StyledConnectSurface>
  );
};

const StyledH2 = styled.h2`
  font-size: 24px;
`;

const StyledConnectSurface = styled(ConnectSurface)`
  flex-grow: 1;
`;
